import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
import { PricingDetailModal } from './PricingDetailModal';
const presenceTags = ['WEB', 'UX', 'FORMULARIOS', 'WHATSAPP', 'ANALYTICS', 'INTEGRACIONES'];
export function WhatToBuild() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section id="sistemas" className="bg-arena py-[56px] md:py-[88px]" data-id="element-329" data-mp="3i3bvibd098yt">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-330" data-mp="3n2yi3beq41ka">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-14 text-center max-w-[600px] mx-auto" data-id="element-331" data-mp="3n5knp5i206zv">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-332" data-mp="1xqmm3iw8slx7">
            ¿QUÉ QUIERES CONSTRUIR?
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1]" data-id="element-333" data-mp="2eyo8sdajncqq">
            Un sistema que se adapte a tu empresa.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-334" data-mp="258v13ndivhrr">
          {/* Presencia Digital */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col bg-arena-dark border border-carbon/10 hover:border-verde/40 hover:-translate-y-[2px] hover:shadow-card rounded-[12px] p-7 md:p-8 transition-all duration-200" data-id="element-335" data-mp="20a1jpjv476mb">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-336" data-mp="2j1azubze4tmv">
              PRESENCIA DIGITAL
            </span>
            <h3 className="font-display text-[19px] font-bold text-carbon mb-2 leading-[1.2]" data-id="element-337" data-mp="17j0118s7qsy1">
              Genera la oportunidad.
            </h3>
            <p className="font-body text-[13.5px] text-carbon/60 leading-[1.6] mb-5 flex-grow" data-id="element-338" data-mp="3vo5oa2i0f4ic">
              Webs y experiencias digitales diseñadas para representar tu
              empresa, generar confianza y convertir visitantes en
              oportunidades.
            </p>
            <div className="flex flex-wrap gap-1.5 mb-6" data-id="element-339" data-mp="3qp2jmj5xz0aw">
              {presenceTags.map(tag => <span key={tag} className="font-body text-[10px] uppercase tracking-[0.06em] text-carbon/45 bg-carbon/5 rounded-full px-2.5 py-1" data-id="element-340" data-mp="3bzwj8rvdb41f">
                  {tag}
                </span>)}
            </div>
            <div className="h-px w-full bg-carbon/10 mb-5" data-id="element-341" data-mp="380xgndx3zjd5" />
            <span className="font-display text-[16px] font-bold text-carbon mb-6" data-id="element-342" data-mp="2t2n1df5oxyma">
              Desde $3.500.000
            </span>
            <a href={getWhatsAppLink('Hola, quiero hablar con ORIGEN sobre Presencia Digital.')} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta transition-all duration-200" data-id="element-343" data-mp="2y1q5mxduk0t7">
              Ver presencia digital <ArrowRight size={15} className="ml-1.5" data-id="element-344" data-mp="2xdr4eei5htcr" />
            </a>
          </motion.div>

          {/* Automatización */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.08
        }} className="flex flex-col bg-arena-dark border border-carbon/10 hover:border-verde/40 hover:-translate-y-[2px] hover:shadow-card rounded-[12px] p-7 md:p-8 transition-all duration-200" data-id="element-345" data-mp="2tbw51fjs5q1m">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-346" data-mp="19ib5n0oj99dq">
              AUTOMATIZACIÓN
            </span>
            <h3 className="font-display text-[19px] font-bold text-carbon mb-2 leading-[1.2]" data-id="element-347" data-mp="1ee9oy9v0817a">
              Se encarga de lo que sucede después.
            </h3>
            <p className="font-body text-[13.5px] text-carbon/60 leading-[1.6] mb-5 flex-grow" data-id="element-348" data-mp="1o54djkvq3cvw">
              IA + WhatsApp + CRM + automatizaciones para atender, calificar
              y hacer seguimiento de cada oportunidad.
            </p>
            <div className="h-px w-full bg-carbon/10 mb-5" data-id="element-349" data-mp="vjl6zgm2f1n9" />
            <span className="font-display text-[16px] font-bold text-carbon mb-6" data-id="element-350" data-mp="10fa0p3belobn">
              Desde $1.200.000 + $300.000/mes
            </span>
            <a href="#precios" className="mt-auto inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta transition-all duration-200" data-id="element-351" data-mp="2bwa3isvdnljx">
              Ver automatización <ArrowRight size={15} className="ml-1.5" data-id="element-352" data-mp="9pri1n47squ" />
            </a>
          </motion.div>

          {/* Sistema Completo */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.16
        }} className="relative flex flex-col bg-carbon text-arena rounded-[12px] p-7 md:p-8 md:-translate-y-2 shadow-cta border border-carbon" data-id="element-353" data-mp="3rlhq04gstm17">
            <span className="absolute -top-3 left-8 font-body text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full bg-azul text-arena" data-id="element-354" data-mp="38ozzfqdors6j">
              ORIGEN SYSTEM
            </span>
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-355" data-mp="16wbuncle8won">
              SISTEMA COMPLETO
            </span>
            <h3 className="font-display text-[19px] font-bold text-arena mb-2 leading-[1.2]" data-id="element-356" data-mp="2wdpao2cptmn8">
              Presencia + automatización. Un solo sistema.
            </h3>
            <p className="font-body text-[13.5px] text-arena/70 leading-[1.6] mb-5 flex-grow" data-id="element-357" data-mp="316s141m74fz7">
              Construimos tu presencia digital y conectamos todo lo que
              sucede después de que alguien muestra interés.
            </p>
            <div className="h-px w-full bg-arena/20 mb-5" data-id="element-358" data-mp="3f5ru1lgqrh16" />
            <span className="font-display text-[16px] font-bold text-arena" data-id="element-359" data-mp="3k3t8tu74wu6u">
              Desde $4.500.000
            </span>
            <span className="font-body text-[11.5px] text-arena/45 mb-6" data-id="element-360" data-mp="357c0lbu8rvoi">
              Implementación + operación mensual según alcance
            </span>
            <button onClick={() => setIsModalOpen(true)} className="mt-auto inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] bg-arena text-carbon hover:bg-[#EAE7E0] hover:-translate-y-[1px] transition-all duration-200" data-id="element-361" data-mp="3a7gin6assygu">
              Construir mi sistema <ArrowRight size={15} className="ml-1.5" data-id="element-362" data-mp="bujzdnktigyn" />
            </button>
          </motion.div>
        </div>
      </div>

      <PricingDetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-363" data-mp="ps8ml22cy06v" />
    </section>;
}